<template>
  <div id="app" :class="{ 'padding-top-class': !userData.currentUser }">
    <div id="nav" v-if="userData.currentUser">
      <div class="desktop">
        <router-link to="/">Home</router-link> |
        <router-link to="/songs">Songs</router-link> |
        <router-link to="/playlists">Playlists</router-link> |
        <router-link to="/new">New</router-link> |
        <router-link to="/archive">Archive</router-link>
      </div>
      <div class="menu">
        <b-dropdown
          id="dropdown-offset"
          offset="25"
          text="Menu"
          class="m-2"
          size="sm"
        >
          <b-dropdown-item href="#"
            ><router-link to="/">Home</router-link></b-dropdown-item
          >
          <b-dropdown-item href="#"
            ><router-link to="/songs">Songs</router-link></b-dropdown-item
          >
          <b-dropdown-item href="#"
            ><router-link to="/playlists"
              >Playlists</router-link
            ></b-dropdown-item
          >
          <b-dropdown-item href="#"
            ><router-link to="/new">New</router-link></b-dropdown-item
          >
          <b-dropdown-item href="#"
            ><router-link to="/archive">Archive</router-link></b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>
    <div v-if="userData.currentUser" class="user">
      <router-link to="/user">
        <span class="user-name">{{ userData.currentUser.displayName }} </span>
      </router-link>
      <b-button size="sm" class="button" @click="logout">Logout</b-button>
    </div>
    <router-view />
    <AudioPlayer ref="audioPlayer" />
  </div>
</template>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-bottom: 100px;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
  .menu {
    position: absolute;
    margin: -8px;
    display: none;
  }
}
.user {
  a,
  a:hover {
    color: #2c3e50;
  }
  position: absolute;
  right: 30px;
  top: 30px;
}
.button {
  margin-left: 5px;
}

.tags {
  .badge {
    margin: 3px;

    svg {
      cursor: pointer;
      height: 12px;
      width: auto;
    }
  }
}

.padding-top-class {
  padding-top: 30px;
}

@media only screen and (max-width: 700px) {
  #nav {
    margin-bottom: 15px;

    .desktop {
      display: none;
    }
    .menu {
      display: block;
    }
  }
  .user-name {
    display: none;
  }
}
</style>

<script>
import { auth, loggedInUser } from "./firebaseConfig";
import router from "./router";
import AudioPlayer from "./components/AudioPlayer.vue";

export default {
  name: "app",
  data() {
    return {
      userData: {
        currentUser: null,
      },
    };
  },
  components: {
    AudioPlayer,
  },
  methods: {
    logout() {
      auth
        .signOut()
        .then(function() {
          console.log("logged out");
          router.push("/login");
        })
        .catch(function(error) {
          console.log("Error logging out", error);
        });
    },
  },
  async mounted() {
    this.userData.currentUser = await loggedInUser;
  },
};
</script>
